import { useState } from "react";
import type { ThemeClasses } from "../types";
import { useCompaniesStore } from "../../../../../../store/admin/companiesStore";
import { DeviceBarridoModal } from "./DeviceBarridoModal";

interface DeviceBarridoButtonProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  t: (key: string, options?: any) => string;
}

export function DeviceBarridoButton({
  themeClasses,
  isDarkMode,
  t,
}: DeviceBarridoButtonProps) {
  const companyId = useCompaniesStore((state) => state.companyId);
  const allCompanies = useCompaniesStore((state) => state.allCompanies);
  const [open, setOpen] = useState(false);

  const company = allCompanies.find((c) => c.id === companyId);
  const companyName =
    company?.name || company?.business_name || companyId || "";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={!companyId}
        title={
          companyId
            ? t("devices.barrido.title")
            : t("devices.barrido.selectCompany")
        }
        className={`px-3 sm:px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 transition-colors whitespace-nowrap text-sm sm:text-base border ${themeClasses.cardBorder} ${themeClasses.buttonHover} ${themeClasses.buttonText} disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        <i className="ri-download-2-line"></i>
        <span>{t("devices.barrido.action")}</span>
      </button>
      {open && companyId && (
        <DeviceBarridoModal
          companyId={companyId}
          companyName={companyName}
          isDarkMode={isDarkMode}
          themeClasses={themeClasses}
          onClose={() => setOpen(false)}
          t={t}
        />
      )}
    </>
  );
}
